import { render, staticRenderFns } from "./RulesAvailabilityForm.vue?vue&type=template&id=23da3b9c&scoped=true"
import script from "./RulesAvailabilityForm.vue?vue&type=script&lang=js"
export * from "./RulesAvailabilityForm.vue?vue&type=script&lang=js"
import style0 from "./RulesAvailabilityForm.vue?vue&type=style&index=0&id=23da3b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da3b9c",
  null
  
)

export default component.exports